import { FilterConfig } from '@/types/filter';

const consentLevelFilter: FilterConfig = {
  label: 'main.channelFocus.hcpCoverage.filters.consentLevelLabel',
  placeholder: 'main.channelFocus.hcpCoverage.filters.consentLevelPlaceholder',
  type: 'multiselect',
  hidden: true,
  options: [
    { label: 'Opt out', value: '1' },
    { label: 'Opt partially', value: '2' },
    { label: 'Opt in', value: '3' },
    { label: 'No consent data', value: '4' },
  ],
  defaultValue: ['0', '1', '2'],
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `hcp_consent_channel_topic_overview.channel_overview`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default consentLevelFilter;
